/* eslint-disable @typescript-eslint/no-unused-vars */

import { isBrowser } from "browser-or-node";
import { Component } from "react";
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators } from 'redux';
import androidActions from "../../store/android/android.actions";

const stateToProps = () => {
	return {};
}

const dispatchToProps = (dispatch) => bindActionCreators({
	appSendData: androidActions.appSendData,
}, dispatch);


const connector = connect(stateToProps, dispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;


type Props = PropsFromRedux & {};

class AndroidConnect extends Component<Props> {
	constructor(props) {
		super(props);
		this.init();
	}

	async init() {
		if (isBrowser) {
			if (window) {
				// @ts-ignore
				window.androidConnect = this;
			}
		}
	}

	functionForAppToCall(dataApp) {
		let elmTorogo = document?.getElementById("torogo");
		let elementTorogo = "";
		if (elmTorogo == null) {
			elementTorogo = "element is null";
		} else {
			elementTorogo = "full element";
		}

		if (dataApp) {
			dataApp.source = "ANDROID";
			this.props?.appSendData(dataApp);
		}
	}

	render() {
		return (
			<div></div>
		);
	}
};


export default connector(AndroidConnect);